/*
 * @Author: randy
 * @Date: 2020-07-31 14:28:42
 * @LastEditTime: 2020-10-22 10:01:18
 * @Description: 普通路由
 */
import EyeUserLayout from "@/layout/EyeStudentLayout";
import CommonLogin from "@/views/login/login";
import ApplySubject from "@/views/applyForsubject/index";
import completeUserInfo from "@/views/completeUserInfo/index";
import CommonUpdatePassword from "@/views/login/update_password";
import Authorization from "@/views/login/authorization";
import BindPhone from "@/views/login/bindphone";
// import Redirect from "@/views/redirect/index";
// 强制修改密码
import UpdatePwd from "@/views/login/update_pwd";

let UserLayout = null;
let Login = null;
let UpdatePassword = null;

if (process.env.VUE_APP_PROJECT_NAME === "eye") {
  UserLayout = EyeUserLayout;
  Login = CommonLogin;
  UpdatePassword = CommonUpdatePassword;
}

const routes = [
  {
    path: "/user",
    name: "UserLayout",
    component: UserLayout,
    children: [
      {
        path: "/user/login",
        name: "Login",
        component: Login
        // component: () =>
        //   import(/* webpackChunkName: "adminlogin" */ "../views/login/admin_login.vue")
      },
      {
        path: "/user/updatepassword",
        name: "UpdatePassword",
        component: UpdatePassword
      },
      {
        path: "/user/updatepwd",
        name: "UpdatePwd",
        component: UpdatePwd
      },
      {
        path: "/user/bindphone",
        name: "BindPhone",
        component: BindPhone
      }
    ]
  },
  {
    path: "/applySubject",
    name: "ApplySubject",
    component: ApplySubject
  },
  {
    path: "/completeUserInfo",
    name: "CompleteUserInfo",
    component: completeUserInfo
  },
  {
    path: "/authorization",
    name: "authorization",
    component: Authorization
  }
  // 用来做刷新
  // {
  //   path: "/redirect",
  //   name: "RedirectUserLayout",
  //   component: UserLayout,
  //   children: [
  //     {
  //       path: "/redirect/:path*",
  //       name: "Redirect",
  //       component: Redirect
  //     }
  //   ]
  // }
];

export default routes;
